// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_dc-b";
export var colorBlue = "_dc-8";
export var colorDot = "_dc-0";
export var colorDotLarge = "_dc-2";
export var colorDotSmall = "_dc-1";
export var colorGreen = "_dc-7";
export var colorGrey = "_dc-3";
export var colorOrange = "_dc-5";
export var colorPink = "_dc-a";
export var colorPurple = "_dc-9";
export var colorRed = "_dc-4";
export var colorYellow = "_dc-6";